import { format, parse } from 'date-fns';

export const EVENT_TYPE_OPTIONS = [
  { value: 'appointment', label: 'Appointment' },
  { value: 'quote_estimate', label: 'Quote / Estimate' },
  { value: 'site_visit', label: 'Site Visit' },
  { value: 'project_work', label: 'Project Work' },
  { value: 'inspection', label: 'Inspection' },
  { value: 'material_delivery', label: 'Material Delivery' },
  { value: 'other', label: 'Other' },
];

export const EVENT_STATUS_OPTIONS = [
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const APPOINTMENT_TYPES = ['appointment', 'quote_estimate', 'site_visit'];

// Colors per unified item_type (manual + auto sources)
export const ITEM_COLORS = {
  appointment: '#D4AF37',
  quote_estimate: '#3B82F6',
  site_visit: '#10B981',
  project_work: '#F59E0B',
  inspection: '#8B5CF6',
  material_delivery: '#14B8A6',
  other: '#9CA3AF',
  project_start: '#22C55E',
  project_target: '#EF4444',
};

export const ITEM_TYPE_LABEL = {
  appointment: 'Appointment',
  quote_estimate: 'Quote / Estimate',
  site_visit: 'Site Visit',
  project_work: 'Project Work',
  inspection: 'Inspection',
  material_delivery: 'Material Delivery',
  other: 'Other',
  project_start: 'Project Start',
  project_target: 'Project Deadline',
};

export const LEGEND_MANUAL = [
  'appointment', 'quote_estimate', 'site_visit', 'project_work', 'inspection', 'material_delivery', 'other',
];
export const LEGEND_AUTO = ['project_start', 'project_target'];

export const SOURCE_OPTIONS = [
  { value: 'all', label: 'All Sources' },
  { value: 'manual_event', label: 'Manual Events' },
  { value: 'project', label: 'Projects' },
];

export const eventTypeLabel = (v) => (EVENT_TYPE_OPTIONS.find((o) => o.value === v) || {}).label || v;
export const eventStatusLabel = (v) => (EVENT_STATUS_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const fmtTime = (hhmm) => {
  if (!hhmm) return null;
  try {
    return format(parse(hhmm, 'HH:mm', new Date()), 'h:mm a');
  } catch {
    return hhmm;
  }
};
